import { Tooltip, Button } from "antd";

const IconButton = ({
  icon,
  text,
  shape,
  title,
  loading,
  onClick,
  htmlType,
  disabled,
  className,
}) => (
  <Tooltip title={title}>
    <Button
      icon={icon}
      shape={shape}
      type="primary"
      loading={loading}
      onClick={onClick}
      htmlType={htmlType}
      disabled={disabled}
      className={className}
    >
      {text ? <span>{text}</span> : text}
    </Button>
  </Tooltip>
);

export default IconButton;
